import React, { useState } from "react";
import { Chat } from "./components/Chat";
import { Auth } from "./components/Auth.js";
import { AppWrapper } from "./components/AppWrapper";
import Cookies from "universal-cookie";
import { Write } from "./write.js";
import { Writes } from "./writes.js";

const cookies = new Cookies();

function ChatApp() {
  const [isAuth, setIsAuth] = useState(cookies.get("auth-token"));
  const [isInChat, setIsInChat] = useState(null);
  const [room, setRoom] = useState("");

  if (!isAuth) {
    return (
      <AppWrapper
        isAuth={isAuth}
        setIsAuth={setIsAuth}
        setIsInChat={setIsInChat}
      >
        <Auth setIsAuth={setIsAuth} />
        <div className="flex flex-col md:flex-row">
          <Write />
          <Writes />
        </div>
      </AppWrapper>
    );
  }

  return (
    <AppWrapper isAuth={isAuth} setIsAuth={setIsAuth} setIsInChat={setIsInChat}>
      {!isInChat ? (
        <div className="relative">
          <div className="absolute top-[80px] left-[100px] right-[100px] flex flex-col items-center">
            <label className="text-2xl font-bold mb-5 text-gray-800">
              TYPE ROOM NAME:
            </label>
            <input
              onChange={(e) => setRoom(e.target.value)}
              className="w-[280px] h-[30px] border-2 border-[#FA7436] rounded-md px-2 text-lg"
            />
            <button
              onClick={() => setIsInChat(true)}
              className="w-[130px] h-[40px] bg-[#302c28] text-white rounded-md mt-5 cursor-pointer"
            >
              Enter Chat
            </button>
          </div>
        </div>
      ) : (
        <Chat room={room} />
      )}
    </AppWrapper>
  );
}

export default ChatApp;
